<template>
  <svg
    class="icon icon-chevron-right"
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="tiny"
    version="1.2"
    viewBox="0 0 28 28"
    :width="width"
    :height="width"
  >
    <title>chevron-up</title>
    <path d="M26.297 20.797l-2.594 2.578c-0.391 0.391-1.016 0.391-1.406 0l-8.297-8.297-8.297 8.297c-0.391 0.391-1.016 0.391-1.406 0l-2.594-2.578c-0.391-0.391-0.391-1.031 0-1.422l11.594-11.578c0.391-0.391 1.016-0.391 1.406 0l11.594 11.578c0.391 0.391 0.391 1.031 0 1.422z"></path>
  </svg>
</template>

<script>
export default {
  name: 'chevronUp',
  props: {
    width: {
      type: Number,
      default: 50,
      required: false
    }
  }
}
</script>